import { TemplateComponentProps } from 'experience-template-renderer-react';
import { useLocation } from 'react-router-dom';
import * as React from 'react';

import { LodgingQueryParamsProvider } from '@shared-ui/search-tools-lodging';
import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, Viewport } from '@shared-ui/viewport-context';

import { useViewTrackerContext } from 'src/common/stores/contexts/viewTracker';

import { Sidebar } from 'components/search/sidebar';
import { SortAndFiltersViewType } from 'src/common/__generated__/api';
import { z } from 'zod';

export const SidebarWrapper: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const viewTracker = useViewTrackerContext();
  const tracker = useClickstreamAnalytics();
  const { config } = templateComponent;
  const location = useLocation();

  const configSchema = z.optional(
    z.object({
      withFilters: z.optional(z.boolean()),
      mapSortAndFilterViewType: z.optional(z.nativeEnum(SortAndFiltersViewType)),
    })
  );
  const result = configSchema.safeParse(config);

  if (!result.success) {
    return null;
  }
  const { withFilters, mapSortAndFilterViewType } = result.data ?? {};

  return (
    <Viewport>
      <ViewLarge>
        <LodgingQueryParamsProvider urlSearchParams={new URLSearchParams(location.search)}>
          <Sidebar
            tracker={tracker}
            viewTracker={viewTracker}
            withFilters={withFilters}
            mapSortAndFilterViewType={mapSortAndFilterViewType}
          />
        </LodgingQueryParamsProvider>
      </ViewLarge>
    </Viewport>
  );
};
